
























































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
const cssPrefix = 'closedNetwork';
@Component({
  components: {
    ...UUIFComponent,
    SwSelect,
  },
})
export default class ClosedNetworkDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @Prop()
  showClosedNetworkDialog: boolean;
  selectedNsmClosedNetworkFileObj: any = '';
  selectedNsmClosedNetworkFile: any = '';

  get selectedProduct() {
    return this.productDetails;
  }

  get nsmClosedNetworkFilesOptions(): SelectOption[] {
    const closedNetworkOptions: any = this.selectedProduct?.nsmClosedNetworkFiles?.map(
      (ele: any) => {
        return {
          id: ele?.nsmpackageid,
          label: ele?.nsmpackagefile,
          value: ele?.nsmpackageid,
          showdownload: ele?.showdownload,
          closedNetworkFileUri: ele?.closedNetworkFileUri,
          closedNetworkFileName: ele?.closedNetworkFileName,
        };
      },
    );
    this.selectedNsmClosedNetworkFileObj = closedNetworkOptions[0] || {};
    this.selectedNsmClosedNetworkFile = closedNetworkOptions[0]?.value || '';
    return closedNetworkOptions;
  }

  handleOnChangeNsmClosedNetworkFile(selectedEle: any) {
    this.selectedNsmClosedNetworkFileObj = this.nsmClosedNetworkFilesOptions?.filter((ele: any) => ele?.value === selectedEle)[0] || {};
  }

  downloadFiles() {
    const url = this.selectedNsmClosedNetworkFileObj?.closedNetworkFileUri || '';
    if (url && this.doesFileExist(url)) {
      const message = this.$t('products.downloadMessage').toString();
      this.$store.commit('enqueueMessage', { infoType: 'informational', infoMsg: message });
      window.location.replace(url);
    } else {
      const message = `${this.$t('products.noDownloadSignatures').toString()}`;
      this.$store.commit('enqueueMessage', { infoType: 'informational', infoMsg: message });
    }
  }

  doesFileExist(urlToFile: string) {
    urlToFile && this.$store.commit('startLoading');
    let isfileExists: boolean = true;
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    try {
      xhr.send();
      /** checking fo the chrome browser **/
      if (xhr.status === 404) {
        isfileExists = false;
      }
    } catch (e) {
      /** checking fo the firefox browser **/
      if (xhr.status === 0 || xhr.status === 404) {
        isfileExists = false;
      }
    } finally {
      this.$store.commit('stopLoading');
    }
    return isfileExists;
  }

  closeDialog(value: boolean = false) {
    this.$emit('closeDialog', value);
  }

  generateFiles() {
    const request = {
      isSigFile: true,
      strSerialNumber: this.selectedProduct?.serialNumber,
      nsmpackageid: this.selectedNsmClosedNetworkFileObj?.value,
      nsmpackagefile: this.selectedNsmClosedNetworkFileObj?.label,
    };
    this.$store
      .dispatch('MswProductsStoreModule/generateCNFiles', request)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response?.msgCode === 'MSWAPP:SUCCESS') {
          this.closeDialog(true);
          this.$store.commit('enqueueMessage', {
            infoType: 'success',
            infoMsg: response?.msgDesc,
          });
        } else {
          this.closeDialog();
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg: response?.msgDesc,
          });
        }
      });
  }
}
